import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { XpoFooterComponent } from './xpo-footer.component';

@NgModule({
  declarations: [XpoFooterComponent],
  imports: [CommonModule, RouterModule],
  exports: [XpoFooterComponent],
  providers: [],
  bootstrap: [XpoFooterComponent],
})
export class XpoFooterModule {}
